import React, {Component} from "react";
import {AnimalKind, animalKindOptions, CastrationStatus, CastrationStatusLabel, DOG_MIX_BREED_ID, sexOptions, SizeType, yesNoOptions} from "../../utils/enums";
import {createOptions, Date, Enums} from "../../utils";
import {BirthDateField, DateField, RadioField, SelectField, TextareaField, TextField} from "../form/form";
import {Col, Row} from "react-bootstrap";
import {Field} from "redux-form";
import PropTypes from "prop-types";
import {parseBirthDate} from "../form/BirthDateField";

export const DogFieldsType = {
	GENERAL: "GENERAL",
	SNAPSHOT: "SNAPSHOT"
}

class DogFields extends Component {

	constructor(props) {
		super(props);

		this.state = {
			animalKind: null,
			breedId: null,
			castrationStatus: null,
			isTat: null,
		}
	}

	componentWillMount() {
		this.syncEnumsAndState(this.props.initialValues);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.initialValues !== this.props.initialValues) {
			this.syncEnumsAndState(nextProps.initialValues);
		}
	}

	syncEnumsAndState(initialValues) {
		const {parent} = this.props;
		const values = parent ? initialValues[parent] : initialValues;
		this.setState({
			breedId: values ? values.breedId : null,
			animalKind: values ? values.animalKind : null,
			castrationStatus: values ? values.castrationStatus : null,
			isTat: values ? values.isTat : null,
		});
	}

	name(name) {
		if (this.props.parent) {
			return this.props.parent + "[" + name + "]";
		}
		return name;
	}

	render() {
		if (this.props.type === DogFieldsType.SNAPSHOT) {
			return this.renderSnapshot();
		} else {
			return this.renderGeneral();
		}
	}

	renderSnapshot() {
		const {fields: {behaviorTitle, isCastration, isChipAndTattoo}} = this.props;
		const {castrationStatus, isTat} = this.state;
		const rows = [];

		rows.push([
			isChipAndTattoo && <Row key={'isTat'}>
				<Col sm={6}>
					<Field label={'Tetování'} name={this.name("isTat")} component={RadioField} options={yesNoOptions}
						onChangeHook={(isTat) => this.setState({isTat})}/>
				</Col>
				{isTat && <Col sm={6}>
					<Field label={'Číslo tetování'} name={this.name("tatNumber")} component={TextField} maxLength={100} sizes={[4, 8]}/>
				</Col>}
			</Row>,
			isChipAndTattoo && isTat && <Row key={'tatDesc'}>
				<Col sm={12}>
					<Field label={'Popis tetování'} name={this.name("tatDesc")} type="text" component={TextareaField}/>
				</Col>
			</Row>,
			isCastration && <Row key={'isCastration'}>
				<Col sm={6}>
					<Field label={'Kastrace'} name={this.name("castrationStatus")} component={RadioField} options={createOptions(CastrationStatusLabel)}
						onChangeHook={(castrationStatus) => this.setState({castrationStatus})}/>
				</Col>
				{castrationStatus === CastrationStatus.YES && <Col sm={6}>
					<Field label={'Datum k.'} title={'Datum kastrace'} name={this.name("castrationDate")} type="text" component={DateField} clearable={true}
						maxDate={Date.today()}/>
				</Col>}
			</Row>,
			<Row key={'visualDesc'}>
				<Col sm={12}>
					<Field label={'Popis vzhledu'} name={this.name("visualDesc")} type="text" component={TextareaField}/>
				</Col>
			</Row>,
			behaviorTitle !== null && <Row key={'behaviorDesc'}>
				<Col sm={12}>
					<Field label={behaviorTitle} name={this.name("behaviorDesc")} type="text" component={TextareaField}/>
				</Col>
			</Row>]);

		return rows;
	}

	renderGeneral() {
		const {parent, initialValues, enums} = this.props;
		const {breedId, animalKind} = this.state;

		const isReadonly = parent && initialValues[parent] && !!initialValues[parent].dogId;
		// const isNew = !(parent ? initialValues[parent] : initialValues).dogId;
		let info = null;
		if (parent) {
			if (isReadonly) {
				info = 'Údaje lze změnit v detailu zvířete.';

			} else {
				info = 'Na základě těchto údajů bude do systému přidáno nové zvíře.'

			}
		}

		const breedOptions = Enums.createEnumItems(enums, Enums.getKey("breed"), true);
		const initialBirthDate = parent && initialValues[parent] ? initialValues[parent].birthDate : initialValues.birthDate;

		return [
			info && <Row key={'info'}><Col sm={12}>
				<div className={'help-block'}>{info}</div>
			</Col></Row>,
			<Row key={'name'}>
				<Col sm={6}>
					<Field label={'Jméno'} name={this.name("name")} placeholder={'Vaše'} type='text' component={TextField} maxLength="100" disabled={isReadonly}/>
				</Col>
				{!parent && <Col sm={6}>
					<Field label={'Ev. číslo'} name={this.name("dogNumber")} type='text' component={TextField} maxLength="20" disabled={isReadonly}/>
				</Col>}
			</Row>,
			!parent && <Row key={'dogNumbers'}>
				<Col sm={6}>
					<Field label={'Další jména'} name={this.name("altNames")} type='text' component={TextField} maxLength="100" disabled={isReadonly}/>
				</Col>
				<Col sm={6}>
					<Field label={'Další čísla'} name={this.name("altDogNumbers")} type='text' component={TextField} maxLength="100" disabled={isReadonly}/>
				</Col>
			</Row>,
			<Row key={'animalKind'} className={!parent && 'divider'}>
				<Col sm={6}>
					<Field label={'Druh'} name={this.name("animalKind")} component={RadioField} options={animalKindOptions} disabled={isReadonly}
						onChangeHook={(v) => {
							this.setState({animalKind: v})
						}}/>
				</Col>
				<Col sm={6}>
					<Field label={'Velikost'} name={this.name("size")} component={SelectField} options={createOptions(SizeType)} disabled={isReadonly}/>
				</Col>
			</Row>,
			<Row key={'kind'}>
				{animalKind !== AnimalKind.OTHER && <Col sm={6}>
					<Field label={'Plemeno'} name={this.name("breedId")} type='text' component={SelectField} options={breedOptions} disabled={isReadonly}
						clearable={true}
						onChangeHook={(v) => {
							this.setState({breedId: v})
						}}/>
				</Col>}
				{breedId === DOG_MIX_BREED_ID && animalKind !== AnimalKind.OTHER && <Col sm={6}>
					<Field label={null} name={this.name("breedDetail")} type='select' component={SelectField} options={breedOptions} disabled={isReadonly}
						emptyText={'Vyberte rasy'} multi={true}/>
				</Col>}
				{breedId && breedId !== DOG_MIX_BREED_ID && animalKind !== AnimalKind.OTHER && <Col sm={6}>
					<Field label={'PP'} name={this.name("isPaper")} component={RadioField} options={yesNoOptions} disabled={isReadonly}/>
				</Col>}
				{animalKind === AnimalKind.OTHER && <Col sm={12}>
					<Field label={'Popis'} name={this.name("breedDetail")} type='text' component={TextField} sizes={[2, 10]} disabled={isReadonly}/>
				</Col>}
			</Row>,
			<Row key={'sex'}>
				<Col sm={6}>
					<Field label={'Pohlaví'} name={this.name("sex")} component={RadioField} options={sexOptions} disabled={isReadonly} sizes={[4, 8]}/>
				</Col>
				<Col sm={6}>
					<Field key={initialBirthDate} label="Nar." title={"Datum narození"} name={this.name("birthDate")} type="text" maxDate={Date.today()}
						allowYearOnly={true}
						component={BirthDateField} maxLength="12" format={(v) => parseBirthDate(v, true)}
						disabled={isReadonly} sizes={[2, 10]}/>
				</Col>
			</Row>,
			!parent && <Row key={'chipNumber'} className={'divider'}>
				<Col sm={6}>
					<Field label={'Pas'} name={this.name("passNumber")} type='text' component={TextField} maxLength="100" disabled={isReadonly}/>
				</Col>
				<Col sm={6}>
					<Field label={'Čip'} name={"chipNumber"} placeholder={'Více čísel oddělte čárkou'} component={TextField} maxLength={100} sizes={[2, 10]}/>
				</Col>
			</Row>
		];
	}
}

DogFields.propTypes = {
	type: PropTypes.string,
	fields: PropTypes.object,
	parent: PropTypes.string,
};

export default DogFields




// WEBPACK FOOTER //
// ./src/components/dog/DogFields.js